import React from 'react'
import { Link } from 'react-router-dom'

const UserComponent = ({id, name = 'Peacegen Indonesia', className, small, image}) => {
  const size = small ? 24 : 40

  const styles = {
    backgroundImage: `url('${image}')`,
    height: `${size}px`,
    width: `${size}px`,
    backgroundSize: '60%'
  }

  let fallbackImage = ''

  if(typeof name === 'number'){
    fallbackImage = name.toString().slice(0,1)
  } else {
    fallbackImage = name.slice(0,1)
  }

  return (
    <div className={`flex items-center ${className}`}>
      <div
        style={styles}
        className="bg-no-repeat bg-center bg-white rounded-full mr-2 flex items-center justify-center shadow"
      >
        {
          !image &&
          <span className="text-gray-600">{fallbackImage}</span>
        }
      </div>
      <p className={`text-sm text-gray-444 ${small ? '' : 'font-bold'}`}>{name}</p>
    </div>
  )
}

const User = (props) => {
  return props.id ?
  <Link to={`/profile/${props.id}`}>
    <UserComponent {...props}/>
  </Link>
  : props.organizationId ?
  <Link to={`/organization/${props.organizationId}`}>
    <UserComponent {...props}/>
  </Link>
  : <UserComponent {...props}/>
}

export { User }
